import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const getKey = (key) => {
    let val = window.localStorage.getItem(key);
    if (val) {
        val = JSON.parse(val)
    }
    return val;
}
const setKey = (key, val) => {
    if (!val) {
        window.localStorage.removeItem(key)
    } else {
        window.localStorage.setItem(key, JSON.stringify(val));
    }
}

export default new Vuex.Store({
    state: {
        userInfo: null, // 登录用户信息
        showLogin: false, // 登录弹窗显示与隐藏
        city: '', // 城市选择
    },
    // getter
    getters: {
        s_getUser(state) {
            return state.userInfo || getKey('userInfo')
        },
        s_getLoginModal(state) {
            return state.showLogin
        },
        s_getCity(state) {
            let info = getKey('cityInfo');
            return state.city || (info ? info.ciy : '')
        }
    },
    // 内置都为同步操作在此处理即可 为setter
    mutations: {
        s_setLoginModal(state, val = 0) {
            state.showLogin = val ? true : false;
        },
        s_setUser(state, val = null) {
            // val = user;
            // setKey('userid', '20093681');
            // setKey('token', token);
            setKey('userInfo', val)
            state.userInfo = val;
            if (!val) {
                setKey('userid', '');
                setKey('token', '');
            }
        },
        s_setCity(state, val = null) {
            setKey('cityInfo', val)
            if (val && val.city) {
                state.city = val.city;
            } else {
                state.city = ''
            }
        },
    },
    // 内置异步操作需在此处理 为setter
    actions: {}
})